export default {
  "Source saved. Existing content is updating in the background.": "Kaynak kaydedildi. Mevcut içerik arka planda güncelleniyor.",
  "Source saved, but the existing content update could not be queued.": "Kaynak kaydedildi ancak mevcut içerik güncellemesi kuyruğa alınamadı.",
  "Source saved; some existing content could not be updated.": "Kaynak kaydedildi; mevcut içeriğin bir kısmı güncellenemedi.",
  "Existing content update completed.": "Mevcut içerik güncellemesi tamamlandı.",
  "Content batches processed": "İşlenen içerik grupları",
  "Update existing content": "Mevcut içeriği güncelle",
  "Choose how to update existing content": "Mevcut içeriğin nasıl güncelleneceğini seçin",
  "Only these changes": "Yalnızca bu değişiklikler",
  "Keep other assignments.": "Diğer atamaları koruyun.",
  "Match new selections": "Yeni seçimlerle eşleştir",
  "Removes other assignments.": "Diğer atamaları kaldırır.",
  "How do these differ?": "Aralarındaki fark nedir?",
  "Update queued": "Güncelleme sıraya alındı",
  "Updating existing content": "Mevcut içerik güncelleniyor",
  "Update complete": "Güncelleme tamamlandı",
  "Update failed": "Güncelleme başarısız",
  "You can close this dialog and return later.": "Bu pencereyi kapatıp daha sonra dönebilirsiniz.",
  "updated": "güncellendi",
  "unchanged": "değişmedi",
  "No changes were saved.": "Hiçbir değişiklik kaydedilmedi.",
  "View details": "Ayrıntıları göster",
  "Applied networks:": "Uygulanan ağlar:",
  "Applied tags:": "Uygulanan etiketler:",
  "Close": "Kapat",
  "Tags": "Etiketler",
  "Networks": "Ağlar",
  "Replace existing assignments": "Mevcut atamaları değiştir",
  "Make existing content match the new selections for changed tags or networks. Manual and unrelated assignments will be removed.": "Mevcut içeriği değiştirilen etiket veya ağların yeni seçimleriyle eşleştirin. Manuel ve ilgisiz atamalar kaldırılır.",
  "Changed dimensions:": "Değiştirilen alanlar:",
  "Final tags:": "Son etiketler:",
  "Final networks:": "Son ağlar:",
  "Only changed dimensions will be replaced. Unchanged tags or networks will be preserved.": "Yalnızca değiştirilen alanlar değiştirilir. Değişmeyen etiketler veya ağlar korunur.",
  "Manual and unrelated assignments in the changed dimensions will be removed. Empty selections clear those assignments. This cannot be undone.": "Değiştirilen alanlardaki manuel ve ilgisiz atamalar kaldırılır. Boş seçimler bu atamaları temizler. Bu işlem geri alınamaz.",
  "Replace existing assignments?": "Mevcut atamalar değiştirilsin mi?",
  "Replace assignments": "Atamaları değiştir",
  "Loading current source settings...": "Geçerli kaynak ayarları yükleniyor...",
  "Source settings could not be loaded. Retry before editing.": "Kaynak ayarları yüklenemedi. Düzenlemeden önce yeniden deneyin.",
  "Retry loading": "Yeniden yükle",
  "Previous tags:": "Önceki etiketler:",
  "Pending tags:": "Bekleyen etiketler:",
  "Apply tag and network changes to existing {{ count }} content item": "Etiket ve ağ değişikliklerini mevcut {{ count }} içeriğe uygula",
  "Apply tag and network changes to existing {{ count }} content items": "Etiket ve ağ değişikliklerini mevcut {{ count }} içeriğe uygula",
  "Apply only tag and network additions or removals made in this update. Other assignments stay unchanged. Differences from older updates are not repaired. This cannot be undone.": "Yalnızca bu güncellemede eklenen veya kaldırılan etiketleri ve ağları uygulayın. Diğer atamalar değişmez. Önceki güncellemelerden kalan farklılıklar düzeltilmez. Bu işlem geri alınamaz.",
  // Magic Login Page
  "Sign in to SociuuHub": "",
  "To make life easy we've skipped lengthy and difficult passwords. Enter your email and check your inbox for an email with a login link.": "",
  "Email Address": "",
  "Email is required.": "",
  "Invalid Email": "",
  "Send magic link": "",
  "Welcome to your<br/>Content Hub": "",
  "To make life easy we’ve skipped lengthy and difficult passwords. Sign in with your Microsoft account, or enter your email to receive a login link.": "Hayatınızı kolaylaştırmak için uzun ve zor şifreleri atladık. Microsoft hesabınızla oturum açın veya giriş bağlantısı almak için e-postanızı girin.",
  "To make life easy we’ve skipped lengthy and difficult passwords. Simply sign in with your Microsoft account to access your SociuuHub.": "Hayatınızı kolaylaştırmak için uzun ve zor şifreleri atladık. SociuuHub'ınıza erişmek için Microsoft hesabınızla oturum açmanız yeterli.",
  "This is your personal Content Hub, where you will find our latest news, social media posts, and job listings that you can share with your network. Enter your email address to gain access.": "Bu, en son haberlerimizi, sosyal medya paylaşımlarımızı ve ağınızla paylaşabileceğiniz iş ilanlarını bulabileceğiniz kişisel İçerik Hub'ınızdır. E-posta adresinizi girin ve erişim sağlayın.",

  // Magic Verify Page
  "Verifying user!": "",

  // Signup Page
  "Signup": "",
  "Signin": "",
  "Sign In": "",
  "Already have an account?": "",
  "First name": "",
  "Last name": "",
  "Email address": "",
  "Phone": "",
  "Department": "",
  "Department is required": "",
  "I agree to the": "",
  "Welcome to": "",
  "Create your account": "",
  "Invalid phone number": "",
  "Allowed domains i.e;": "",
  "Email address or Phone number is required": "",
  "Invalid domain": "",
  "Please enter a valid email address": "",
  "Last name is required": "",
  "Whitespaces are not allowed": "",
  "First name is required": "",

  // Content Hub
  "No contents match your current filters.": "Mevcut filtrelerinizle eşleşen içerik yok.",
  "No contents were found.": "İçerik bulunamadı.",
  "Reset filters or adjust your search to see available content.": "Mevcut içerikleri görmek için filtreleri sıfırlayın veya aramanızı değiştirin.",
  "Reset filters": "Filtreleri sıfırla",
  "Apply network changes to existing {{ count }} content item": "Ağ değişikliklerini mevcut {{ count }} içeriğe uygula",
  "Apply network changes to existing {{ count }} content items": "Ağ değişikliklerini mevcut {{ count }} içeriğe uygula",
  "Apply this update": "Bu güncellemeyi uygula",
  "Apply only the network additions or removals made in this update. Other content-level assignments remain unchanged.": "Yalnızca bu güncellemede eklenen veya kaldırılan ağları uygulayın. İçerik düzeyindeki diğer atamalar değişmeden kalır.",
  "Source update:": "Kaynak güncellemesi:",
  "Refresh runs in the background. Sources with an ongoing source update will refresh after that update finishes. Other sources refresh normally. You can close this dialog and continue working.": "Yenileme arka planda çalışır. Kaynak güncellemesi devam eden kaynaklar, güncelleme tamamlandıktan sonra içerik getirir. Diğer kaynaklar normal şekilde yenilenir. Bu pencereyi kapatıp çalışmaya devam edebilirsiniz.",
  "We are refreshing your Content Hub.": "Content Hub yenileniyor.",
  "This source is being updated. Try again after the update finishes.": "Bu kaynak güncelleniyor. Güncelleme tamamlandıktan sonra tekrar deneyin.",
  "Previous networks:": "Önceki ağlar:",
  "Pending networks:": "Bekleyen ağlar:",
  "Eligible existing content:": "Uygun mevcut içerik:",
  "Changed existing content:": "Değiştirilen mevcut içerik:",
  "Queued": "Sırada",
  "Processing": "İşleniyor",
  "Completed": "Tamamlandı",
  "Failed": "Başarısız",
  "None": "Yok",
  "Apply tag changes separately before applying network changes to existing content.": "Mevcut içeriğe ağ değişikliklerini uygulamadan önce etiket değişikliklerini ayrı olarak uygulayın.",
  "Choose how to apply these tag and network changes to existing content.": "Bu etiket ve ağ değişikliklerinin mevcut içeriğe nasıl uygulanacağını seçin.",
  "Source update queued. You can close this dialog and return later.": "Kaynak güncellemesi sıraya alındı. Bu pencereyi kapatıp daha sonra dönebilirsiniz.",
  "The source update could not be queued.": "Kaynak güncellemesi sıraya alınamadı.",
  "The source update could not be prepared. Close the source and try again.": "Kaynak güncellemesi hazırlanamadı. Kaynağı kapatıp yeniden deneyin.",
  "The confirmation could not be shown, so nothing was changed. Please try again.": "Onay gösterilemedi, bu nedenle hiçbir şey değiştirilmedi. Lütfen yeniden deneyin.",
  'Retry saved update':
    'Kaydedilen güncellemeyi yeniden dene',
  'Retry the saved settings, not unsaved edits in this form.':
    'Bu formdaki kaydedilmemiş değişiklikleri değil, kaydedilen ayarları yeniden deneyin.',
  'The saved source update could not be retried.':
    'Kaydedilen kaynak güncellemesi yeniden denenemedi.',
  'The source changed after this operation failed. Reopen the source before retrying.':
    'Bu işlem başarısız olduktan sonra kaynak değişti. Yeniden denemeden önce kaynağı tekrar açın.',
  "Source updated. {{ count }} existing content item changed.": "Kaynak güncellendi. {{ count }} mevcut içerik değiştirildi.",
  "Source updated. {{ count }} existing content items changed.": "Kaynak güncellendi. {{ count }} mevcut içerik değiştirildi.",
  "The source update failed. No changes were saved.": "Kaynak güncellemesi başarısız oldu. Hiçbir değişiklik kaydedilmedi.",
  "Operation failed. Reopen the source and try again.": "İşlem başarısız oldu. Kaynağı yeniden açıp tekrar deneyin.",
  "The completed source settings could not be refreshed. Close and reopen the source before editing.": "Güncellenen kaynak ayarları yeniden yüklenemedi. Düzenlemeden önce kaynağı kapatıp yeniden açın.",

  // Welcome modal
  "Hi {{ userName }}": "Merhaba {{ userName }}",
  "Welcome to our social media hub. Take part in sharing all our great stories, news, job posts and more.": "Sosyal medya merkezimize hoş geldiniz. Tüm harika hikayelerimizi, haberlerimizi, iş ilanlarımızı ve daha fazlasını paylaşmaya katılın.",
  "Every share counts.": "",
  "Get started right here": "Hemen buradan başlayın",

  // PDF preview
  "This PDF could not be previewed. Please check that the file is valid and try again.": "Bu PDF önizlenemedi. Dosyanın geçerli olduğunu kontrol edip tekrar deneyin.",
  "Password-protected PDFs cannot be previewed. Please upload an unprotected PDF.": "Parola korumalı PDF'ler önizlenemez. Korumasız bir PDF yükleyin.",
  "This PDF preview could not be loaded. Please try again.": "Bu PDF önizlemesi yüklenemedi. Tekrar deneyin.",
  "This PDF could not be previewed. Please try another PDF.": "Bu PDF önizlenemedi. Başka bir PDF deneyin.",
  "Please wait for the PDF preview to finish loading": "Lütfen PDF önizlemesinin yüklenmesini bekleyin",

  // Image uploads
  "Image type is not valid": "Görsel türü geçerli değil",
  "GIF images for LinkedIn must be smaller than 5 MB": "LinkedIn için GIF görselleri 5 MB'den küçük olmalıdır",
  "LinkedIn image file size exceeds 50 MB limit": "LinkedIn görsel dosyası boyutu 50 MB sınırını aşıyor",
  "Image dimensions is not valid": "Görsel boyutları geçerli değil",
  "Error processing image file": "Görsel dosyası işlenirken hata oluştu",
  "Error reading image file": "Görsel dosyası okunurken hata oluştu",

  // Auto-flow / Content Selection
  "Sender identity": "Gönderen kimliği",
  "Sender name": "Gönderen adı",
  "Write the name recipients should see as the email sender.": "Alıcıların e-posta göndereni olarak görmesini istediğiniz adı yazın.",
  "AutoFlow default sender": "AutoFlow varsayılan göndereni",
  "Maximum 100 characters.": "En fazla 100 karakter.",
  "From:": "Kimden:",
  "Cancel": "İptal",
  "Save": "Kaydet",
  "Sender name saved.": "Gönderen adı kaydedildi.",
  "Support chat is temporarily unavailable. Please try again later.": "Destek sohbeti geçici olarak kullanılamıyor. Lütfen daha sonra tekrar deneyin.",
  'Needs an image for {{ networks }}': '{{ networks }} için bir görsel gerekiyor',
  'and': 've',
  'Used when this is shared to {{ networks }}.': 'Bu içerik {{ networks }} üzerinde paylaşıldığında kullanılır.',
  'On {{ origin }} the original {{ origin }} post is reshared, so these changes don\'t show there.':
    '{{ origin }} üzerinde orijinal {{ origin }} gönderisi yeniden paylaşılır, bu nedenle bu değişiklikler orada görünmez.',
  'This video is shared only on {{ origin }}, where the original {{ origin }} post is reshared, so these changes don\'t show there.':
    'Bu video yalnızca {{ origin }} üzerinde paylaşılır; orada orijinal {{ origin }} gönderisi yeniden paylaşılır, bu nedenle bu değişiklikler orada görünmez.',
};
